import axios from 'axios';

export const fetchConsentsPdf = (path) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
    return axios.get('/api/download'+path, {responseType: 'blob'});
};
